// Latest-request-wins gate for async loads that can overlap (e.g. the invoice email composer: a new
// payment description, then a template switch). Every call to the returned runner starts a new
// request; only the reply of the LATEST request is handed back ({ latest: true, value }). An older
// reply, or an older failure, comes back as { latest: false } and must be dropped by the caller.
export type LatestResult<T> = { latest: true; value: T } | { latest: false };

export function latestOnly() {
  let seq = 0;
  return async function run<T>(load: () => Promise<T>): Promise<LatestResult<T>> {
    const mine = ++seq;
    try {
      const value = await load();
      return mine === seq ? { latest: true, value } : { latest: false };
    } catch (e) {
      if (mine !== seq) return { latest: false };
      throw e;
    }
  };
}
